import { Dialog } from '../../../components/general/dialog/dialog';
import ClientForm from './data';
import { useClientFormModal } from './hook';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    setIsOpen: (v: boolean) => void;
    threadId: string;
    idTender?: string;
    isOnlyView: boolean;
}

export const ClientFormModal = ({
    isOpen,
    onClose,
    setIsOpen,
    threadId,
    idTender,
    isOnlyView,
}: Props) => {
    const { setFormikTender, handleSubmit, disabled, modalTitle, loading } =
        useClientFormModal({
            setIsOpen,
            threadId,
            isOnlyView,
            idTender,
            isOpen,
        });

    return (
        <Dialog
            open={isOpen}
            title={modalTitle}
            onClose={onClose}
            textSecondBtn="Guardar"
            disabledSecondBtn={disabled || isOnlyView}
            onClickSecondBtn={handleSubmit}
        >
            <ClientForm
                onChangeFormik={setFormikTender}
                isOnlyView={isOnlyView}
                idTender={idTender}
            />
            {loading && <p>Cargando datos...</p>}
        </Dialog>
    );
};
